// Pixels per wheel "line" (deltaMode === 1). Matches the browser default step
// used for line-mode wheels so a line wheel scrolls comparably to a pixel wheel.
const WHEEL_LINE_HEIGHT_PX = 16;

const WHEEL_DELTA_MODE_LINE = 1;
const WHEEL_DELTA_MODE_PAGE = 2;

export const getMaxScrollLeft = (
  contentWidth: number,
  viewportWidth: number
): number => Math.max(0, contentWidth - viewportWidth);

export const clampScrollLeft = (value: number, maxScrollLeft: number): number =>
  Math.min(Math.max(value, 0), Math.max(0, maxScrollLeft));

interface WheelDeltaSource {
  deltaX: number;
  deltaY: number;
  deltaMode: number;
  shiftKey: boolean;
}

// Horizontal scroll distance (in px) for a wheel event. Trackpads emit `deltaX`
// directly on a two-finger horizontal swipe; a mouse wheel only scrolls
// horizontally while Shift is held. Line/page `deltaMode` values are scaled to
// pixels so the step is comparable to a pixel wheel.
export const resolveHorizontalWheelDelta = (
  event: WheelDeltaSource,
  pageSize: number
): number => {
  let delta = 0;

  if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
    delta = event.deltaX;
  } else if (event.shiftKey) {
    delta = event.deltaY;
  }

  if (delta === 0) {
    return 0;
  }

  if (event.deltaMode === WHEEL_DELTA_MODE_LINE) {
    return delta * WHEEL_LINE_HEIGHT_PX;
  }

  if (event.deltaMode === WHEEL_DELTA_MODE_PAGE) {
    return delta * pageSize;
  }

  return delta;
};
